module.exports = __webpack_public_path__ + "static/media/innovationIcon.76db9809.png";